module.exports = __webpack_public_path__ + "static/media/red_bike.9f0f178a.png";